import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useForm } from '@inertiajs/vue3';
    import DialogForm from '@/components/DialogForm.vue';
    import DataFieldForm from '@/components/data-fields/DataFieldForm.vue';
    import QueryKey from '@/enums/QueryKey';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CreateDataField',
  setup(__props) {

    const form = useForm({
        data_field_name: '',
        data_field_status: '',
        data_field_group: '',
        data_field_color: '',
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DialogForm, {
    type: "create",
    form: _unref(form),
    route: _ctx.route('v2.data-fields.store'),
    "query-key": [_unref(QueryKey).DATA_FIELDS],
    title: "system.add_data_field",
    "button-text": "system.add_data_field"
  }, {
    default: _withCtx(() => [
      _createVNode(DataFieldForm, { form: _unref(form) }, null, 8, ["form"])
    ]),
    _: 1
  }, 8, ["form", "route", "query-key"]))
}
}

})